<template>
  <div>
    <div class="tabList">
      <div class="tabItem"
           v-for="(item, index) in tabList"
           @click="handleChange(item.name)"
          :class="{ active: $route.path.includes(item.name) }"
          :key="'t' + index">{{item.label}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlanList',
  props: {
    tabList: {
      type: Array,
      default: () => {
        return []
      }
    },
    url: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      activeName: ''
    }
  },
  watch: {
    '$route.path' (val) {
      this.activeName = val.substr(this.$route.path.lastIndexOf('/') + 1)
    }
  },
  created () {
    this.activeName = this.$route.path.substr(this.$route.path.lastIndexOf('/') + 1)
  },
  methods: {
    handleChange (name) {
      this.activeName = name
      const path = `/${this.url}/${this.activeName}`
      if (this.$route.path !== path) {
        this.$router.replace({ path: path })
      }
    }
  }
}
</script>

<style scoped lang='scss'>
  .tabList {
    display: flex;
    width: 100%;
    height: 40px;
    background: #f5f5f5;
    overflow: auto;
    .tabItem {
      flex-shrink: 0;
      font-family: PingFang SC;
      font-size: 14px;
      height: 40px;
      color: #0D1550;
      padding: 12px 10px;
      cursor: pointer;
      &:not(:last-child) {
        margin-right: 20px;
      }
      &.active {
        position: relative;
        color: #0040FF;
        &::after {
          content: '';
          position: absolute;
          right: calc(50% - 7px);
          bottom: 0px;
          width: 14px;
          height: 2px;
          background: #3060FF;
          border-radius: 1px;
        }
      }
    }
  }
</style>
